// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import { store } from '../../../store/store';

import { fetchEquipmentDetails } from '../../../store/equipment/equipmentActions';

// Prevent multiple simultaneous loads during launch (shouldRevalidate takes
// care of it after that)
let isFetching = false;

export async function equipmentLoader({ params }) {
  const { equipmentId } = params;

  if (!equipmentId) {
    return null;
  }

  if (isFetching) {
    return null;
  }

  // get equipment by id
  const state = store.getState();
  const companyUuid = state.companies?.company?.company_uuid;

  if (!companyUuid) {
    return null;
  }

  isFetching = true;
  await store.dispatch(fetchEquipmentDetails({ companyUuid, equipUUID: equipmentId }));
  isFetching = false;

  return null;
}

equipmentLoader.hydrate = true;
